/**
 * @generated SignedSource<<11ac5c23f220e081c9b47c0a22720088>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueRow_nativeIssueTable_IssueRowWithFragments_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellColor_project">;
  readonly " $fragmentType": "issueRow_nativeIssueTable_IssueRowWithFragments_project";
};
export type issueRow_nativeIssueTable_IssueRowWithFragments_project$key = {
  readonly " $data"?: issueRow_nativeIssueTable_IssueRowWithFragments_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueRow_nativeIssueTable_IssueRowWithFragments_project",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useCellColor_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "830522e81ff9e53dfa5f55908968abe8";

export default node;
